import { FC, Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import Box from '@mui/material/Box'

import { GRAY_800 } from 'constants/styling/theme'
import { EmptyContent } from 'components/common/EmptyContent'
import { MUIButton } from 'components/common/MUIButton'
import { useCanUserOrder } from 'utils/user/canUserOrder'

import { useStartOrderForProperty } from '../_main/useStartOrderForProperty'

interface Props {
  propertyId: string,
  beforeClickEvent: () => void,
}

export const ClientPropertyEmptyDocumentsGalleryComponent: FC<Props> = ({ propertyId, beforeClickEvent }) => {
  const { t } = useTranslation(['gallery'])
  const { startOrder, completionDrawer } = useStartOrderForProperty()
  const canUserOrder = useCanUserOrder()

  return (
    <Fragment>
    <Box maxWidth="60rem" width="100%" margin="auto" marginTop="8rem">
      <EmptyContent
        title={t('client_gallery.no_assignment_document')}
        icon={<ArticleOutlinedIcon sx={{ color: GRAY_800, fontSize: '2.8rem' }} />}
        button={
          canUserOrder && (
            <MUIButton
              sx={{ marginTop: '2.4rem' }}
              onClick={() => {
                beforeClickEvent()
                startOrder()
              }}
            >
              {t('client_gallery.no_assignment_document_action')}
            </MUIButton>
          )
        }
      />
    </Box>
    {completionDrawer}
    </Fragment>
  )
}
